// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wB0Fa","header":"styles_header__2aDA0","headerText":"styles_headerText__vxtal","boldTitle":"styles_boldTitle__CY+KX"};